export enum MouseButtons {
  LEFT = 1,
  MIDDLE = 4,
  RIGHT = 2,
}

export enum Axis {
  X = 'x',
  Y = 'y',
  Z = 'z',
}
